<template>
  <!-- Лента тикета филиала: дни-пилюли, пузыри, строки событий, прижата к низу (p4, p5) -->
  <div ref="scroller" class="feed-list" @scroll="onScroll">
    <div class="feed-list__inner">
      <div v-if="hasMore" class="feed-list__older">
        <v-btn
          small
          depressed
          class="feed-list__older-btn text-normalize"
          :loading="loadingOlder"
          @click="$emit('older')"
        >
          Показать раньше
        </v-btn>
      </div>

      <template v-for="group in groups">
        <div :key="`day-${group.label}`" class="feed-list__day">
          <span>{{ group.label }}</span>
        </div>
        <template v-for="item in group.items">
          <message-bubble
            v-if="item.kind === 'message'"
            :key="`m-${item.id}`"
            :message="item"
            :highlighted="item.id === highlightedId"
            @menu="$emit('menu', $event)"
            @photo="$emit('photo', $event)"
            @quote="scrollToMessage"
          />
          <div
            v-else-if="eventOf(item)"
            :key="`e-${item.id}`"
            class="feed-list__event"
            :class="`feed-list__event--${eventOf(item).tone}`"
          >
            <span>
              <v-icon v-if="eventOf(item).tone === 'green'" size="16">mdi-check-circle-outline</v-icon>
              {{ eventOf(item).text }}
            </span>
          </div>
        </template>
      </template>

      <!-- Карточка оценки под строкой «Обращение решено» -->
      <slot name="after" />
    </div>
  </div>
</template>

<script>
  import MessageBubble from './MessageBubble.vue'
  import { eventLine, groupByDay } from '../feed'

  // Ближе этого к низу - считаем, что человек читает свежее, и прижимаем ленту на новых сообщениях.
  const STICK_PX = 120
  const HIGHLIGHT_MS = 1600

  export default {
    name: 'FeedList',
    components: { MessageBubble },
    props: {
      items: { type: Array, required: true },
      appealNumber: { type: Number, required: true },
      hasMore: { type: Boolean, default: false },
      loadingOlder: { type: Boolean, default: false },
    },
    data () {
      return { atBottom: true, highlightedId: null, keepFromBottom: null }
    },
    computed: {
      groups () {
        return groupByDay(this.items)
      },
    },
    watch: {
      items (next, prev) {
        const prependedOlder = prev.length && next.length > prev.length && next[0] !== prev[0]
        const scroller = this.$refs.scroller
        if (prependedOlder && scroller) {
          // Подгрузили старые сверху: держим глазами то же место.
          this.keepFromBottom = scroller.scrollHeight - scroller.scrollTop
        }
        this.$nextTick(() => {
          if (this.keepFromBottom != null) {
            scroller.scrollTop = scroller.scrollHeight - this.keepFromBottom
            this.keepFromBottom = null
          } else if (this.atBottom) {
            this.scrollToBottom()
          }
        })
      },
    },
    mounted () {
      this.scrollToBottom()
    },
    methods: {
      eventOf (item) {
        return eventLine(item, this.appealNumber)
      },
      onScroll () {
        const el = this.$refs.scroller
        this.atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < STICK_PX
      },
      scrollToBottom () {
        const el = this.$refs.scroller
        if (el) el.scrollTop = el.scrollHeight
      },
      // Клик по цитате: оригинал в ленте - прокрутка и короткая подсветка.
      scrollToMessage (id) {
        const node = this.$el.querySelector(`#message-${id}`)
        if (!node) return
        node.scrollIntoView({ behavior: 'smooth', block: 'center' })
        this.highlightedId = id
        setTimeout(() => {
          if (this.highlightedId === id) this.highlightedId = null
        }, HIGHLIGHT_MS)
      },
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

.feed-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

// Лента прижата к низу, пока сообщений мало
.feed-list__inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  min-height: 100%;
  padding: 16px 0;
}

.feed-list__older {
  text-align: center;
}

.feed-list__older-btn {
  background-color: @fakt-surface !important;
}

.feed-list__day {
  text-align: center;

  span {
    display: inline-block;
    height: 24px;
    padding: 0 12px;
    border-radius: 100px;
    font-size: 12px;
    line-height: 24px;
    color: @fakt-text-2;
    background: @fakt-surface;
  }
}

.feed-list__event {
  font-size: 12px;
  text-align: center;
  color: @fakt-text-3;

  &--green span {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    height: 28px;
    padding: 0 12px;
    border-radius: 100px;
    font-weight: 500;
    color: @fakt-green;
    background: @fakt-success-soft;

    .v-icon {
      color: @fakt-green !important;
    }
  }
}
</style>
